import { render, staticRenderFns } from "./AdminSubdomain.vue?vue&type=template&id=98cb4f66&scoped=true"
import script from "./AdminSubdomain.vue?vue&type=script&lang=js"
export * from "./AdminSubdomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cb4f66",
  null
  
)

export default component.exports